import { Injectable } from '@angular/core';
import { environment } from '@app/env';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { MediaObjectModel } from '../../libs/component-lib/components/media-object/media-object.model';
import { FulfilmentStatusConstant } from '../../libs/component-lib/constants/fulfilment-status.constant';
import { EvsbThankYouOutboundModel, EvsbThankYouOutboundModelItem } from './evsb-thank-you-outbound.model';

@Injectable()
export class EvsbThankYouOutboundMapper {
  public map(language: string): EvsbThankYouOutboundModel {
    return {
      title: marker('modules.evcSmallBiz.thankYouOutbound.title'),
      alert: this.getAlert(),
      items: this.getItems(),
      navigation: this.getNavigate(language),
    };
  }

  private getAlert(): MediaObjectModel {
    return {
      src: './assets/evc/img/contact.svg',
      text: marker('modules.evcSmallBiz.thankYouOutbound.alert.text'),
    };
  }

  private getItems(): EvsbThankYouOutboundModelItem[] {
    const items = [] as EvsbThankYouOutboundModelItem[];

    items.push({
      completed: true,
      title: marker(`modules.evcSmallBiz.thankYouOutbound.fulfilment.1.title`),
      status: FulfilmentStatusConstant.completed,
    });
    items.push({
      completed: true,
      title: marker(`modules.evcSmallBiz.thankYouOutbound.fulfilment.2.title`),
      text: marker(`modules.evcSmallBiz.thankYouOutbound.fulfilment.2.text`),
      status: FulfilmentStatusConstant.checkMailbox,
    });
    items.push({
      completed: true,
      title: marker(`modules.evcSmallBiz.thankYouOutbound.fulfilment.3.title`),
      text: marker(`modules.evcSmallBiz.thankYouOutbound.fulfilment.3.text`),
      status: FulfilmentStatusConstant.progress,
    });

    return items;
  }

  private getNavigate(language: string): string {
    if (language === 'nl') {
      return `${environment.websiteUrl}/${environment.electricDrivingNl}`;
    }

    return `${environment.websiteUrl}/${environment.electricDrivingFr}`;
  }
}
